import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { http } from "Utils/http";
import { store } from 'Store';
import { TextButton } from "Components/Button";
import DatatableBase from "Components/Datatable/DatatableBase";
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import { Col } from "react-bootstrap";


const ListVendorAuth = ({...props}) => {

  const listVendorOrgs = "Search by Organization Name and ID";

  const loginState = store.getState().loginInfo;
  const isPSOPPCAdmin = props.isPSOPPCAdmin;
  // Flag: trigger api to reload data
  const [reloadListVendorOrgs, setReloadListVendorOrgs] = useState(false);
  const [selectedPSOOrg, setSelectedPSOOrg] = useState({});
  const [listVendorOrgsSortColumn, setListVendorOrgsSortColumn] = useState({
    sortField: "vendorName",
    sortDirection: "asc"
  });

  const navigate = useNavigate();

  const vendorAuthTableTitle = "Vendor Authorizations";
  const vendorAuthTableDes = "Select a Vendor Authorization to view detailed information";


  // Date format: mm/dd/yyyy hh: mm
  const handleDateFormat = (time) => {
    if (time == null) {
      return;
    }

    let date = new Date(time);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    return (
      <div>
        {month < 10 ? "0" + month : month}/
        {day < 10 ? "0" + day : day}/
        {year + " "}
      </div>
    )
  }


  const getData = async (filter) => {
    var call = {
      ...filter
    }
    //console.log("call get vendor org list");
    var url = '/api/organization/vendor-authorization/list';

    return http.post(url, call, {
      headers: {
        "Authorization": "Bearer " + loginState.token
      }
    });
  }

  const getListCols = (selectedList, sortingInfo) => {
    const listColumns = [];

    const nameState = function ({ rowName }) {
      if (selectedPSOOrg && Object.keys(selectedPSOOrg).length === 0) {
        setSelectedPSOOrg({
          psoOrg: rowName.psoId + " " + rowName.psoName,
          orgId: rowName.psoOrganizationId
        });
      }

      //console.log("print out rowName", rowName);
      return { id: rowName.id };
    }

    const vendorInfoState = function ({ rowName }) {
      //console.log("print out vendorInfoState", rowName);
      return {
        vendorInfo: rowName
      }
    }

    listColumns.push(Datatable_Column({ name: "Vendor Name", columnName: "vendorName", selectedRows: selectedList, sortable: true, sortFieldNum: 3, isLink: isPSOPPCAdmin, linkData: { title: "", pathname: "/manage/viewVendorAuthorization", text: null, state: nameState }, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "Vendor ID", columnName: "vendorId", selectedRows: selectedList, sortable: true, sortFieldNum: 2, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "PSO Name", columnName: "psoName", selectedRows: selectedList, sortable: true, sortFieldNum: 1, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "PSO ID", columnName: "psoId", selectedRows: selectedList, sortable: true, sortFieldNum: 0, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "Start Date", columnName: "startDate", selectedRows: selectedList, sortable: true, sortFieldNum: 4, formatFunction: handleDateFormat, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "End Date", columnName: "endDate", selectedRows: selectedList, sortable: true, sortFieldNum: 5, formatFunction: handleDateFormat, sortingInfo: sortingInfo }));
    isPSOPPCAdmin && listColumns.push(Datatable_Column({ name: "Edit", columnName: "edit", selectedRows: selectedList, sortable: false, sortFieldNum: 6, isLink: true, linkData: { title: "", pathname: "/manage/editVendorAuthorization", text: "Edit", state: vendorInfoState }, sortingInfo: sortingInfo }));

    return listColumns;
  }

  const addVendorAuth = () => {
    //console.log("get select pso org", selectedPSOOrg);
    navigate("/manage/addVendorAuthorization", { state: selectedPSOOrg });
  }

  // useEffect(() => {
  //   const res = getData({
  //     "startIndex": 0,
  //     "entryPerPage": 5,
  //     "sortingColumn": null,
  //     "sortingOrder": null,
  //     "searchTerm": "v0000"
  //   })
  // }, []);


  return (
    <>
      <DatatableBase
        tableClassName="vendorAuthTable"
        reload={reloadListVendorOrgs}
        setReload={setReloadListVendorOrgs}
        getData={getData}
        getListCols={getListCols}
        //setSelected={setSelected}
        //hasSelectableRows={true}
        searchFieldText={listVendorOrgs}
        datatableHeader={vendorAuthTableTitle}
        datatableDescription={isPSOPPCAdmin ? vendorAuthTableDes : null}
        sortingColumn={listVendorOrgsSortColumn.sortField}
        sortingOrder={listVendorOrgsSortColumn.sortDirection}
      >
        { isPSOPPCAdmin &&
          <Col className="d-flex justify-content-end ">
            <TextButton
              className="ms-auto"
              onClick={addVendorAuth}
              variant="normal"
              content={"Add Vendor Authorization"}
            />
          </Col>
        }
      </DatatableBase>
    </>
  )
}


export default ListVendorAuth;
